'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('cisco-ui/dist/css/cui-standard.min.css');
var React = require('react');
var classnames = require('classnames');
var tslib = require('tslib');
var reactRouterDom = require('react-router-dom');
var reactTable = require('react-table');
var reactBeautifulDnd = require('react-beautiful-dnd');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classnames__default = /*#__PURE__*/_interopDefaultLegacy(classnames);

function Icon(_a) {
    var _b;
    var name = _a.name, className = _a.className, _c = _a.testId, testId = _c === void 0 ? '' : _c;
    var classes = classnames__default['default'](className, (_b = {},
        _b["icon-" + name] = true,
        _b));
    return (React__default['default'].createElement("span", { className: classes, "data-testid": testId, role: "img", "aria-label": "Icon" }));
}

function stopEventBubbling(onClick) {
    return function (event) {
        event.stopPropagation();
        onClick(event);
    };
}

function Button(_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.colour, colour = _c === void 0 ? 'default' : _c, _d = _a.size, size = _d === void 0 ? 'default' : _d, onClick = _a.onClick, testId = _a.testId, rest = tslib.__rest(_a, ["children", "className", "colour", "size", "onClick", "testId"]);
    var classes = classnames__default['default']('btn', "btn--" + size, "btn--" + colour, className);
    return (React__default['default'].createElement("button", tslib.__assign({}, rest, { onClick: onClick ? stopEventBubbling(onClick) : undefined, className: classes, "data-testid": testId }), children));
}

function IconButton(_a) {
    var className = _a.className, icon = _a.icon, props = tslib.__rest(_a, ["className", "icon"]);
    var classes = classnames__default['default']('btn--circle', className);
    return (React__default['default'].createElement(Button, tslib.__assign({}, props, { className: classes }),
        React__default['default'].createElement(Icon, { name: icon })));
}

var styles$d = {"close":"Alert-module_close__2dVtU"};

var ICONS = {
    dark: 'help-outline',
    info: 'info-outline',
    light: 'help-outline',
    success: 'check-outline',
    warning: 'warning-outline',
    'warning-alt': 'warning-outline',
};
function Alert(_a) {
    var _b;
    var _c = _a.showIcon, showIcon = _c === void 0 ? false : _c, children = _a.children, className = _a.className, _d = _a.colour, colour = _d === void 0 ? 'info' : _d, onDismiss = _a.onDismiss;
    var classes = classnames__default['default']('alert', className, (_b = {},
        _b["alert--" + colour] = !!colour,
        _b));
    var iconName = ICONS[colour] || 'info';
    return (React__default['default'].createElement("div", { className: classes, role: "alert" },
        showIcon && (React__default['default'].createElement("div", { className: "alert__icon" },
            React__default['default'].createElement(Icon, { name: iconName }))),
        React__default['default'].createElement("div", { className: "alert__message" }, children),
        onDismiss && (React__default['default'].createElement("span", { className: styles$d.close },
            React__default['default'].createElement(IconButton, { className: "alert__close", icon: "close", colour: "link", size: "large", onClick: onDismiss })))));
}

function Card(_a) {
    var _b;
    var _c = _a.borderType, borderType = _c === void 0 ? 'none' : _c, children = _a.children, className = _a.className, _d = _a.loose, loose = _d === void 0 ? true : _d, _e = _a.raised, raised = _e === void 0 ? true : _e, testId = _a.testId, _f = _a.well, well = _f === void 0 ? false : _f;
    var classes = classnames__default['default']('panel', 'clearfix', className, (_b = {},
        _b["panel--" + borderType] = !!borderType,
        _b['panel--loose'] = loose,
        _b['panel--raised'] = raised,
        _b['panel--well'] = well,
        _b));
    return (React__default['default'].createElement("div", { className: classes, "aria-label": "Card", "data-testid": testId }, children));
}

function CardContent(_a) {
    var children = _a.children, className = _a.className;
    var classes = classnames__default['default'](className);
    return (React__default['default'].createElement("div", { className: classes, "aria-label": "Card body" }, children));
}

function CardFooter(_a) {
    var className = _a.className, children = _a.children;
    return (React__default['default'].createElement("div", { className: className, "aria-label": "Card footer" }, children));
}

function CardHeader(_a) {
    var className = _a.className, children = _a.children;
    return (React__default['default'].createElement("div", { className: className, "aria-label": "Card header" }, children));
}

function Checkbox(_a) {
    var disabled = _a.disabled, label = _a.label, id = _a.id, checked = _a.checked, rest = tslib.__rest(_a, ["disabled", "label", "id", "checked"]);
    var classes = classnames__default['default']('checkbox', {
        disabled: disabled,
    });
    return (React__default['default'].createElement("label", { className: classes, htmlFor: id },
        React__default['default'].createElement("input", tslib.__assign({ type: "checkbox", checked: checked, disabled: disabled, id: id }, rest)),
        React__default['default'].createElement("span", { className: "checkbox__input", "aria-checked": checked }),
        label && React__default['default'].createElement("span", { className: "checkbox__label" }, label)));
}

var LINKS = [
    {
        href: 'https://www.cisco.com/c/en/us/about/contact-cisco.html',
        name: 'Contacts',
    },
    {
        href: 'https://secure.opinionlab.com/ccc01/o.asp?id=jBjOhqOJ',
        name: 'Feedback',
    },
    {
        href: 'http://www.cisco.com/c/en/us/about/sitemap.html',
        name: 'Help',
    },
    {
        href: 'http://www.cisco.com/c/en/us/about/sitemap.html',
        name: 'Site Map',
    },
    {
        href: 'https://www.cisco.com/c/en/us/about/legal/terms-conditions.html',
        name: 'Terms & Conditions',
    },
    {
        href: 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html',
        name: 'Privacy Statement',
    },
    {
        href: 'https://www.cisco.com/c/en/us/about/legal/privacy-full.html#cookies',
        name: 'Cookie Policy',
    },
    {
        href: 'https://www.cisco.com/c/en/us/about/legal/trademarks.html',
        name: 'Trademarks',
    },
];

function Footer(_a) {
    var _b;
    var className = _a.className, _c = _a.colour, colour = _c === void 0 ? 'default' : _c, _d = _a.links, links = _d === void 0 ? LINKS : _d;
    var classes = classnames__default['default']('footer', className, (_b = {},
        _b["footer--" + colour] = colour !== 'default',
        _b));
    return (React__default['default'].createElement("footer", { className: classes },
        React__default['default'].createElement("div", { className: "footer__links" },
            React__default['default'].createElement("ul", { className: "list list--inline" }, links.map(function (_a) {
                var name = _a.name, href = _a.href;
                return (React__default['default'].createElement("li", { key: name },
                    React__default['default'].createElement("a", { href: href, target: "_blank", rel: "noreferrer noopener" }, name)));
            })))));
}

function FormGroup(_a) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.errors, errors = _c === void 0 ? [] : _c, _d = _a.horizontal, horizontal = _d === void 0 ? false : _d, _e = _a.inline, inline = _e === void 0 ? false : _e, spacing = _a.spacing, testId = _a.testId;
    var classes = classnames__default['default']('form-group', className, (_b = {
            'form-group--error': errors.length,
            'form-group--horizontal': horizontal,
            'form-group--inline': inline
        },
        _b["form-group--" + spacing] = !!spacing,
        _b));
    return (React__default['default'].createElement("div", { className: classes, "data-testid": testId },
        children,
        errors.map(function (error) { return (React__default['default'].createElement("div", { key: error, className: "help-block", role: "alert" },
            React__default['default'].createElement("span", null, error))); })));
}

function FormGroupText(_a) {
    var children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b, testId = _a.testId;
    var classes = classnames__default['default']('form-group__text', className);
    return (React__default['default'].createElement("div", { className: classes, "data-testid": testId }, children));
}

var styles$c = {"root":"Header-module_root__1SPn1","link":"Header-module_link__1L24a","title":"Header-module_title__1Efo2"};

function Header(_a) {
    var center = _a.center, title = _a.title, logoLinkTo = _a.logoLinkTo, right = _a.right, left = _a.left;
    return (React__default['default'].createElement("header", { className: classnames__default['default']('header', styles$c.root) },
        React__default['default'].createElement("div", { className: "header-panels dbl-padding-left dbl-padding-right" },
            React__default['default'].createElement("div", { className: "header-panel" },
                React__default['default'].createElement(reactRouterDom.Link, { "data-testid": "header-logo-link", to: logoLinkTo, className: "header__logo" },
                    React__default['default'].createElement(Icon, { name: "cisco" })),
                React__default['default'].createElement("div", { className: classnames__default['default']('header__title', styles$c.title) },
                    React__default['default'].createElement(reactRouterDom.Link, { to: logoLinkTo, className: styles$c.link }, title),
                    left)),
            center && (React__default['default'].createElement("div", { className: "header-panel header-panel--center" }, center)),
            right && (React__default['default'].createElement("div", { className: "header-panel header-panel--right" }, right)))));
}

var styles$b = {"tab":"NavLinks-module_tab__2INCw","active":"NavLinks-module_active__ipzWs"};

function NavLinks(_a) {
    var links = _a.links;
    return (React__default['default'].createElement("nav", { "aria-label": "header-nav", className: "header-item" },
        React__default['default'].createElement("ul", { className: "tabs" }, links.map(function (_a) {
            var _b;
            var active = _a.active, link = tslib.__rest(_a, ["active"]);
            return (React__default['default'].createElement("li", { key: link.label, className: classnames__default['default']('tab', styles$b.tab, (_b = {
                        active: active
                    },
                    _b[styles$b.active] = active,
                    _b)) },
                React__default['default'].createElement(reactRouterDom.Link, { to: link.to, className: styles$b.tab },
                    React__default['default'].createElement("div", { className: "tab__heading" }, link.label))));
        }))));
}

var ThemeContext = React.createContext(undefined);
function useTheme() {
    var context = React.useContext(ThemeContext);
    if (!context) {
        throw new Error('themeContext must be used inside a ThemeProvider');
    }
    return context;
}
function ThemeProvider(_a) {
    var children = _a.children;
    var _b = React.useState('dark'), theme = _b[0], setTheme = _b[1];
    React.useEffect(function () {
        document.body.dataset.theme = theme;
    }, [theme]);
    return (React__default['default'].createElement(ThemeContext.Provider, { value: [theme, setTheme] }, children));
}

function Switch(_a) {
    var checked = _a.checked, id = _a.id, labelLeft = _a.labelLeft, labelRight = _a.labelRight, _b = _a.disabled, disabled = _b === void 0 ? false : _b, value = _a.value, rest = tslib.__rest(_a, ["checked", "id", "labelLeft", "labelRight", "disabled", "value"]);
    var classes = classnames__default['default']('switch', {
        disabled: disabled,
    });
    return (React__default['default'].createElement("label", { className: classes, htmlFor: id },
        React__default['default'].createElement("input", tslib.__assign({ checked: checked, type: "checkbox", disabled: disabled, value: value, id: id }, rest)),
        labelLeft && React__default['default'].createElement("span", { className: "switch__label" }, labelLeft),
        React__default['default'].createElement("span", { className: "switch__input", "aria-checked": checked }),
        labelRight && React__default['default'].createElement("span", { className: "switch__label" }, labelRight)));
}

var ThemeSwitch = function (_a) {
    var _b = _a.labelLeft, labelLeft = _b === void 0 ? '' : _b, _c = _a.labelRight, labelRight = _c === void 0 ? '' : _c;
    var _d = useTheme(), theme = _d[0], setTheme = _d[1];
    var handleThemeSwitch = function () {
        var newTheme = theme === 'light' ? 'dark' : 'light';
        setTheme(newTheme);
    };
    return (React__default['default'].createElement("div", { className: "header-item" },
        React__default['default'].createElement(Switch, { checked: theme === 'dark', labelLeft: labelLeft, labelRight: labelRight, onChange: function () { return handleThemeSwitch(); } })));
};

var DEFAULT_PROPS = {
    align: 'center',
    size: '64',
    weight: '300',
};
function Heading(_a) {
    var _b;
    var HeadingLevel = _a.level, children = _a.children, _c = _a.className, className = _c === void 0 ? '' : _c, _d = _a.size, size = _d === void 0 ? DEFAULT_PROPS.size : _d, _e = _a.weight, weight = _e === void 0 ? DEFAULT_PROPS.weight : _e, _f = _a.align, align = _f === void 0 ? DEFAULT_PROPS.align : _f;
    var classes = classnames__default['default']("text-size-" + size + " text-weight-" + weight + " text-" + align, (_b = {},
        _b[className] = !!className,
        _b));
    return React__default['default'].createElement(HeadingLevel, { className: classes }, children);
}

function Image(_a) {
    var alt = _a.alt, className = _a.className, src = _a.src;
    return React__default['default'].createElement("img", { alt: alt, className: className, src: src });
}

function Label(_a) {
    var _b;
    var _c = _a.bordered, bordered = _c === void 0 ? false : _c, children = _a.children, _d = _a.className, className = _d === void 0 ? '' : _d, _e = _a.colour, colour = _e === void 0 ? 'primary' : _e, _f = _a.size, size = _f === void 0 ? 'default' : _f, _g = _a.testId, testId = _g === void 0 ? '' : _g;
    var classes = classnames__default['default']('label', (_b = {},
        _b[className] = !!className,
        _b["label--bordered"] = bordered,
        _b["label--" + colour] = colour !== 'primary',
        _b["label--" + size] = size !== 'default',
        _b));
    return (React__default['default'].createElement("span", { className: classes, "data-testid": testId }, children));
}

function LinkButton(_a) {
    var children = _a.children, className = _a.className, _b = _a.colour, colour = _b === void 0 ? 'default' : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c, testId = _a.testId, to = _a.to;
    var classes = classnames__default['default']('btn', "btn--" + size, "btn--" + colour, className);
    return (React__default['default'].createElement(reactRouterDom.Link, { className: classes, to: to, "data-testid": testId }, children));
}

var styles$a = {"accessibleMessage":"LoaderWrapper-module_accessibleMessage__1yZqG"};

function LoaderWrapper(_a) {
    var _b = _a.ariaLabel, ariaLabel = _b === void 0 ? 'Loading, please wait...' : _b, _c = _a.accessibleLoadedMessage, accessibleLoadedMessage = _c === void 0 ? 'Content Loaded' : _c, _d = _a.accessibleLoadingMessage, accessibleLoadingMessage = _d === void 0 ? 'Content Loading' : _d, children = _a.children, className = _a.className, _e = _a.show, show = _e === void 0 ? true : _e;
    return (React__default['default'].createElement("div", { className: className, "aria-label": ariaLabel, role: "alert", "aria-live": "assertive" },
        show ? children : null,
        React__default['default'].createElement("p", { className: styles$a.accessibleMessage }, show ? accessibleLoadingMessage : accessibleLoadedMessage)));
}

function LoaderDots(_a) {
    var _b = _a.colour, colour = _b === void 0 ? 'primary' : _b, rest = tslib.__rest(_a, ["colour"]);
    var classes = "loading-dots loading-dots--" + colour;
    return (React__default['default'].createElement(LoaderWrapper, tslib.__assign({}, rest, { className: classes }),
        React__default['default'].createElement("span", null),
        React__default['default'].createElement("span", null),
        React__default['default'].createElement("span", null)));
}

function LoaderSpinner(_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, rest = tslib.__rest(_a, ["size"]);
    var classes = "loader loader--" + size;
    return (React__default['default'].createElement(LoaderWrapper, tslib.__assign({}, rest, { className: classes }),
        React__default['default'].createElement("div", { className: "wrapper" },
            React__default['default'].createElement("div", { className: "wheel" }))));
}

function NavigationTabs(_a) {
    var tabs = _a.tabs;
    return (React__default['default'].createElement("nav", { "aria-label": "navigation-tabs" },
        React__default['default'].createElement("ul", { className: "tabs" }, tabs.map(function (_a) {
            var label = _a.label, pathname = _a.pathname;
            return (React__default['default'].createElement("li", { className: classnames__default['default']('tab', {
                    active: window.location.pathname.includes(pathname),
                }), key: label },
                React__default['default'].createElement(reactRouterDom.Link, { to: pathname },
                    React__default['default'].createElement("div", { className: "tab__heading", title: label }, label))));
        }))));
}

function NumberInput(_a) {
    var className = _a.className, error = _a.error, _b = _a.horizontal, horizontal = _b === void 0 ? false : _b, id = _a.id, label = _a.label, labelClass = _a.labelClass, required = _a.required, rest = tslib.__rest(_a, ["className", "error", "horizontal", "id", "label", "labelClass", "required"]);
    var classes = classnames__default['default']({ error: error });
    return (React__default['default'].createElement(FormGroup, { horizontal: horizontal, errors: error ? [error] : [], className: className },
        React__default['default'].createElement(FormGroupText, null,
            label && (React__default['default'].createElement("label", { className: labelClass, htmlFor: id },
                label,
                " ",
                required && '*')),
            React__default['default'].createElement("input", tslib.__assign({ id: id, type: "number", className: classes }, rest)))));
}

/**
 * Determines which ellipsis are required to be displayed
 * and returns either none, both, left or right
 *
 * @param {number} current The currently active link
 * @param {number} pages The number of pages in the range
 * @return {string} Either 'none', 'both', 'left' or 'right'
 */
var determineEllipsisLocation = function (current, pages) {
    var showLeftEllipsis = current > MAX_NUM_LINKS - 1 && pages > MAX_NUM_LINKS;
    var showRightEllipsis = current < pages - MAX_NUM_MIDDLE_LINKS;
    if (showLeftEllipsis && showRightEllipsis) {
        return 'both';
    }
    else if (showLeftEllipsis && !showRightEllipsis) {
        return 'left';
    }
    else if (!showLeftEllipsis && showRightEllipsis) {
        return 'right';
    }
    return 'none';
};
/**
 * Determines the start value of the middle links (of which
 * there can be a maximum of 3) and the number of links to show.
 *
 * @param {string} showEllipsis Either 'none', 'both', 'left' or 'right'
 * @param {number} current The currently active link
 * @param {number} pages The number of pages in the range
 * @return {array} The first element is the start value in the middle links
 * and the second element is the number of middle links to show (max 3)
 */
var determineMiddleLinksConfig = function (showEllipsis, current, pages) {
    if (pages < 2)
        return [0, 0];
    switch (showEllipsis) {
        case 'none':
        case 'right':
            return [
                DEFAULT_FIRST_MIDDLE_VAL,
                pages - MAX_NUM_MIDDLE_LINKS > DEFAULT_FIRST_MIDDLE_VAL
                    ? MAX_NUM_MIDDLE_LINKS
                    : pages - (MAX_NUM_LINKS - MAX_NUM_MIDDLE_LINKS),
            ];
        case 'left':
            return [pages - MAX_NUM_MIDDLE_LINKS, MAX_NUM_MIDDLE_LINKS];
        default:
            return [current - 1, MAX_NUM_MIDDLE_LINKS];
    }
};

var MAX_NUM_LINKS = 5;
var MAX_NUM_MIDDLE_LINKS = 3;
var DEFAULT_FIRST_MIDDLE_VAL = 2;
var defaultProps = {
    rounded: false,
    size: 'default',
};
function Pagination(_a) {
    var current = _a.current, pages = _a.pages, onClick = _a.onClick, rest = tslib.__rest(_a, ["current", "pages", "onClick"]);
    var _b = React.useState('none'), showEllipsis = _b[0], setShowEllipses = _b[1];
    var _c = React.useState([0, 0]), middleButtonValues = _c[0], setMiddleButtonValues = _c[1];
    React.useEffect(function () {
        setShowEllipses(determineEllipsisLocation(current, pages));
        setMiddleButtonValues(determineMiddleLinksConfig(showEllipsis, current, pages));
    }, [current, pages, showEllipsis]);
    var renderMiddleButtons = function () {
        var first = middleButtonValues[0], numOfButtons = middleButtonValues[1];
        return Array(numOfButtons)
            .fill(0)
            .map(function (_, i) { return (React__default['default'].createElement(PaginationItem, tslib.__assign({}, rest, { key: i, value: first + i, selected: first + i === current, onClick: function () { return onClick(first + i); } }))); });
    };
    if (pages < current) {
        return null;
    }
    return (React__default['default'].createElement("ul", { className: "pagination" },
        React__default['default'].createElement(PaginationItem, tslib.__assign({}, rest, { value: "Previous", selected: false, disabled: current <= 1, onClick: function () { return onClick(current - 1); } })),
        React__default['default'].createElement(PaginationItem, tslib.__assign({}, rest, { value: 1, selected: current === 1, onClick: function () { return onClick(1); } })),
        (showEllipsis === 'left' || showEllipsis === 'both') && (React__default['default'].createElement("li", null,
            React__default['default'].createElement(Icon, { name: "more" }))),
        renderMiddleButtons(),
        (showEllipsis === 'right' || showEllipsis === 'both') && (React__default['default'].createElement("li", null,
            React__default['default'].createElement(Icon, { name: "more" }))),
        pages > 1 && (React__default['default'].createElement(PaginationItem, tslib.__assign({}, rest, { value: pages, selected: current === pages, onClick: function () { return onClick(pages); } }))),
        React__default['default'].createElement(PaginationItem, tslib.__assign({}, rest, { value: "Next", selected: false, disabled: current === pages, onClick: function () { return onClick(current + 1); } }))));
}
Pagination.defaultProps = defaultProps;

var styles$9 = {"button":"Pagination-module_button__AEtY6","button--active":"Pagination-module_button--active__y1LDs","button--rounded":"Pagination-module_button--rounded__GeAZr","button--large":"Pagination-module_button--large__1TeT3","button--small":"Pagination-module_button--small__2g8dR"};

function PaginationItem(_a) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 'default' : _d, _e = _a.selected, selected = _e === void 0 ? false : _e, value = _a.value, _f = _a.disabled, disabled = _f === void 0 ? false : _f, _g = _a.rounded, rounded = _g === void 0 ? false : _g, onClick = _a.onClick;
    var classes = classnames__default['default'](styles$9.button + " " + styles$9["button--" + size], (_b = {}, _b[styles$9['button--active']] = !!selected, _b), (_c = {}, _c[styles$9['button--rounded']] = !!rounded, _c));
    return (React__default['default'].createElement("li", null,
        React__default['default'].createElement("button", { disabled: disabled, className: classes, onClick: selected ? undefined : onClick }, value)));
}

var styles$8 = {"root":"Search-module_root__29UzK"};

function Search(_a) {
    var id = _a.id, label = _a.label, onChange = _a.onChange, placeholder = _a.placeholder, value = _a.value;
    var classes = classnames__default['default']('form-group input--icon', styles$8.root);
    return (React__default['default'].createElement("div", { className: classes },
        React__default['default'].createElement(FormGroupText, null,
            React__default['default'].createElement("input", { id: id, type: "search", onChange: onChange, placeholder: placeholder, value: value }),
            label && React__default['default'].createElement("label", { htmlFor: id }, label),
            React__default['default'].createElement(IconButton, { icon: "search", className: "link", "aria-label": "Search" }))));
}

function Select(_a) {
    var className = _a.className, _b = _a.errors, errors = _b === void 0 ? [] : _b, id = _a.id, _c = _a.inline, inline = _c === void 0 ? false : _c, label = _a.label, options = _a.options, rest = tslib.__rest(_a, ["className", "errors", "id", "inline", "label", "options"]);
    return (React__default['default'].createElement(FormGroup, { errors: errors, inline: inline, className: className },
        React__default['default'].createElement(FormGroupText, { className: "select" },
            React__default['default'].createElement("select", tslib.__assign({ id: id }, rest), options.map(function (option) { return (React__default['default'].createElement("option", { value: option.value, key: option.name }, option.name)); })),
            React__default['default'].createElement("label", { htmlFor: id }, label))));
}

var styles$7 = {"isNested":"SideTabsLink-module_isNested__cEklA"};

function SideTabsLink(_a) {
    var pathname = _a.pathname, label = _a.label, isNested = _a.isNested;
    function creatListItemClasses(pathname) {
        return classnames__default['default']('tab', {
            active: window.location.pathname.includes(pathname),
        });
    }
    function createDivClasses() {
        var _a;
        return classnames__default['default']('tab__heading', (_a = {},
            _a[styles$7.isNested] = isNested,
            _a));
    }
    return (React__default['default'].createElement("li", { className: creatListItemClasses(pathname), key: label },
        React__default['default'].createElement(reactRouterDom.Link, { to: pathname },
            React__default['default'].createElement("div", { className: createDivClasses(), title: label }, label))));
}

var styles$6 = {"root":"NestedLinksButton-module_root__2gOCY","label":"NestedLinksButton-module_label__1UiY7","icon":"NestedLinksButton-module_icon__zBwgW"};

function NestedLinksButton(_a) {
    var _b;
    var handleOnClick = _a.handleOnClick, label = _a.label, isActive = _a.isActive;
    return (React__default['default'].createElement("button", { className: classnames__default['default'](styles$6.root, styles$6.chevron, (_b = {},
            _b[styles$6['active']] = isActive,
            _b)), onClick: handleOnClick },
        React__default['default'].createElement("span", { className: styles$6.label }, label),
        React__default['default'].createElement(Icon, { className: styles$6.icon, name: isActive ? 'chevron-up' : 'chevron-down' })));
}

function NestedLinks(_a) {
    var tabs = _a.tabs, label = _a.label;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    React.useEffect(function () {
        var labelToPath = label.replace(/\s+/g, '-').toLowerCase();
        if (window.location.pathname.includes(labelToPath))
            setIsOpen(true);
    }, [label]);
    return (React__default['default'].createElement("li", null,
        React__default['default'].createElement(NestedLinksButton, { handleOnClick: function () { return setIsOpen(!isOpen); }, label: label, isActive: isOpen }),
        React__default['default'].createElement("div", { hidden: !isOpen },
            React__default['default'].createElement("ul", { className: "tabs tabs--vertical hidden-xs hidden-sm" }, tabs.map(function (tab) { return (React__default['default'].createElement(SideTabsLink, { key: tab.label, pathname: tab.pathname, label: tab.label, isNested: true })); })))));
}

function SideTabs(_a) {
    var tabs = _a.tabs;
    return (React__default['default'].createElement("nav", { "aria-label": "side-nav" },
        React__default['default'].createElement("ul", { className: "tabs tabs--vertical hidden-xs hidden-sm" }, tabs.map(function (tab) {
            return 'pathname' in tab ? (React__default['default'].createElement(SideTabsLink, { key: tab.label, pathname: tab.pathname, label: tab.label })) : (React__default['default'].createElement(NestedLinks, { key: tab.label, tabs: tab.sideTabs, label: tab.label }));
        }))));
}

function Step(_a) {
    var _b;
    var _c = _a.active, active = _c === void 0 ? false : _c, _d = _a.className, className = _d === void 0 ? '' : _d, label = _a.label, _e = _a.size, size = _e === void 0 ? 'default' : _e, _f = _a.step, step = _f === void 0 ? 0 : _f, _g = _a.testId, testId = _g === void 0 ? '' : _g, _h = _a.visited, visited = _h === void 0 ? false : _h;
    var classes = classnames__default['default']('step', (_b = {
            active: active
        },
        _b[className] = !!className,
        _b.visited = visited,
        _b));
    var content = React.useMemo(function () { return (visited ? React__default['default'].createElement(Icon, { name: "check" }) : step); }, [
        step,
        visited,
    ]);
    return (React__default['default'].createElement("div", { className: classes, "data-testid": testId },
        React__default['default'].createElement("div", { className: "step__icon" }, size !== 'dot' && content),
        React__default['default'].createElement("div", { className: "step__label" }, label)));
}

function Steps(_a) {
    var _b;
    var colour = _a.colour, children = _a.children, _c = _a.size, size = _c === void 0 ? 'default' : _c, _d = _a.subheaderText, subheaderText = _d === void 0 ? '' : _d, _e = _a.testId, testId = _e === void 0 ? '' : _e, _f = _a.vertical, vertical = _f === void 0 ? false : _f;
    var classes = classnames__default['default']('steps', (_b = {},
        _b["steps--" + colour] = !!colour,
        _b["steps--" + size] = !!size,
        _b['steps--vertical'] = vertical,
        _b));
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        subheaderText && (React__default['default'].createElement("div", { className: "subheader text-center" }, subheaderText)),
        React__default['default'].createElement("div", { className: classes, "data-testid": testId }, React.Children.map(children, function (child, i) {
            return React.isValidElement(child)
                ? React.cloneElement(child, { step: i + 1 })
                : child;
        }))));
}

var styles$5 = {"root":"ResizeHandle-module_root__1l1-8","active":"ResizeHandle-module_active__2kiVm"};

function ResizeHandle(_a) {
    var _b;
    var className = _a.className, column = _a.column;
    return (React__default['default'].createElement("div", tslib.__assign({}, column.getResizerProps(), { style: { cursor: 'col-resize' }, className: classnames__default['default'](styles$5.root, className, (_b = {},
            _b[styles$5.active] = column.isResizing,
            _b)) })));
}

var styles$4 = {"table":"Table-module_table__8ew8A","heading":"Table-module_heading__37VGu","col":"Table-module_col__1NygX","emptyHead":"Table-module_emptyHead__Velss","emptyDragHandleHead":"Table-module_emptyDragHandleHead__1DYqP","row":"Table-module_row__2cwjq","head":"Table-module_head__3Vegf","icon":"Table-module_icon__3PEuF","descending":"Table-module_descending__3aDiv","actions":"Table-module_actions__2brDl","hasActions":"Table-module_hasActions__2-mxK"};

var hooks$1 = [
    reactTable.useSortBy,
    reactTable.useResizeColumns,
    reactTable.useFlexLayout,
    reactTable.usePagination,
    reactTable.useRowSelect,
];
var DEFAULT_PAGE_SIZE = 100;
function Table(_a) {
    var _b;
    var actions = _a.actions, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? '' : _c, className = _a.className, columns = _a.columns, data = _a.data, initialState = _a.initialState, _d = _a.pluginHooks, pluginHooks = _d === void 0 ? [] : _d, rowClassName = _a.rowClassName;
    var tableHooks = tslib.__spreadArray(tslib.__spreadArray([], hooks$1), pluginHooks);
    var tableInitialState = tslib.__assign({ pageSize: DEFAULT_PAGE_SIZE }, initialState);
    var _e = reactTable.useTable.apply(void 0, tslib.__spreadArray([{
            columns: columns,
            data: data,
            defaultColumn: {
                maxWidth: 300,
                minWidth: 20,
            },
            initialState: tableInitialState,
        }], tableHooks)), headerGroups = _e.headerGroups, getTableBodyProps = _e.getTableBodyProps, getTableProps = _e.getTableProps, gotoPage = _e.gotoPage, prepareRow = _e.prepareRow, page = _e.page, pageCount = _e.pageCount, pageIndex = _e.state.pageIndex;
    var rowClasses = classnames__default['default'](styles$4.row, rowClassName, (_b = {},
        _b[styles$4.hasActions] = !!actions,
        _b));
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("div", tslib.__assign({ className: classnames__default['default']('table', styles$4.table, className), "aria-label": ariaLabel }, getTableProps()),
            React__default['default'].createElement("div", { className: styles$4.head },
                React__default['default'].createElement("div", { className: rowClasses }, headerGroups.map(function (headerGroup) { return (React__default['default'].createElement("div", tslib.__assign({}, headerGroup.getHeaderGroupProps()),
                    headerGroup.headers.map(function (column) {
                        var _a;
                        return (React__default['default'].createElement("div", tslib.__assign({}, column.getHeaderProps(column.getSortByToggleProps()), { className: styles$4.heading }),
                            column.render('Header'),
                            column.isSorted ? (React__default['default'].createElement(Icon, { name: "dropdown", className: classnames__default['default'](styles$4.icon, (_a = {},
                                    _a[styles$4.descending] = column.isSortedDesc,
                                    _a)) })) : (''),
                            column.canResize && React__default['default'].createElement(ResizeHandle, { column: column })));
                    }),
                    actions && React__default['default'].createElement("div", { className: styles$4.emptyHead }, "\u00A0"))); }))),
            React__default['default'].createElement("div", tslib.__assign({}, getTableBodyProps()), page.map(function (row) {
                prepareRow(row);
                return (React__default['default'].createElement("div", tslib.__assign({}, row.getRowProps(), { className: rowClasses }),
                    row.cells.map(function (cell) {
                        return (React__default['default'].createElement("div", tslib.__assign({}, cell.getCellProps(), { className: styles$4.col, title: typeof cell.value === 'string' ? cell.value : undefined }), cell.render('Cell')));
                    }),
                    actions && (React__default['default'].createElement("div", { className: styles$4.actions, "data-test": "actions" }, actions(row.original)))));
            }))),
        pageCount > 1 && (React__default['default'].createElement("div", { "data-test": "pagination" },
            React__default['default'].createElement(Pagination, { current: pageIndex + 1, pages: pageCount, onClick: function (page) {
                    gotoPage(page - 1);
                } })))));
}

var styles$3 = {"root":"DragHandle-module_root__1--Rc"};

function DragHandle(props) {
    return (React__default['default'].createElement("div", tslib.__assign({}, props, { className: styles$3.root }),
        React__default['default'].createElement(Icon, { name: "list-menu" })));
}

var styles$2 = {"isDragging":"DraggableContainer-module_isDragging__15tAs"};

function DraggableContainer(_a) {
    var _b;
    var isDragging = _a.isDragging, children = _a.children, className = _a.className, innerRef = _a.innerRef, rest = tslib.__rest(_a, ["isDragging", "children", "className", "innerRef"]);
    var classes = classnames__default['default'](className, [styles$2.root], (_b = {},
        _b[styles$2.isDragging] = isDragging,
        _b));
    return (React__default['default'].createElement("div", tslib.__assign({ ref: innerRef, className: classes }, rest), children));
}

var hooks = [reactTable.useResizeColumns, reactTable.useFlexLayout, reactTable.useRowSelect];
function TableDraggableRows(_a) {
    var _b;
    var actions = _a.actions, _c = _a.ariaLabel, ariaLabel = _c === void 0 ? '' : _c, className = _a.className, columns = _a.columns, data = _a.data, handleOnRowDrag = _a.handleOnRowDrag, _d = _a.pluginHooks, pluginHooks = _d === void 0 ? [] : _d, rowClassName = _a.rowClassName;
    var tableHooks = tslib.__spreadArray(tslib.__spreadArray([], hooks), pluginHooks);
    var _e = reactTable.useTable.apply(void 0, tslib.__spreadArray([{
            columns: columns,
            data: data,
            defaultColumn: {
                maxWidth: 300,
                minWidth: 20,
            },
        }], tableHooks)), headerGroups = _e.headerGroups, getTableBodyProps = _e.getTableBodyProps, getTableProps = _e.getTableProps, prepareRow = _e.prepareRow, rows = _e.rows;
    var rowClasses = classnames__default['default'](styles$4.row, rowClassName, (_b = {},
        _b[styles$4.hasActions] = !!actions,
        _b));
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("div", tslib.__assign({ className: classnames__default['default']('table', styles$4.table, className), "aria-label": ariaLabel }, getTableProps()),
            React__default['default'].createElement("div", { className: styles$4.head },
                React__default['default'].createElement("div", { className: rowClasses }, headerGroups.map(function (headerGroup) { return (React__default['default'].createElement("div", tslib.__assign({}, headerGroup.getHeaderGroupProps()),
                    headerGroup.headers.map(function (column) { return (React__default['default'].createElement("div", tslib.__assign({}, column.getHeaderProps(), { className: styles$4.heading }),
                        column.render('Header'),
                        column.canResize && React__default['default'].createElement(ResizeHandle, { column: column }))); }),
                    actions && React__default['default'].createElement("div", { className: styles$4.emptyHead }, "\u00A0"),
                    React__default['default'].createElement("div", { className: styles$4.emptyDragHandleHead }, "\u00A0"))); }))),
            React__default['default'].createElement(reactBeautifulDnd.DragDropContext, { onDragEnd: handleOnRowDrag },
                React__default['default'].createElement(reactBeautifulDnd.Droppable, { droppableId: "droppable" }, function (droppableProvided) {
                    return (React__default['default'].createElement(React__default['default'].Fragment, null,
                        React__default['default'].createElement("div", tslib.__assign({}, droppableProvided.droppableProps, getTableBodyProps(), { ref: droppableProvided.innerRef, role: "row" }),
                            rows.map(function (row, index) {
                                prepareRow(row);
                                return (React__default['default'].createElement(reactBeautifulDnd.Draggable, { draggableId: row.id, index: index, key: row.index }, function (draggableProvided, snapshot) { return (React__default['default'].createElement(DraggableContainer, tslib.__assign({ className: rowClasses, key: index, innerRef: draggableProvided.innerRef, isDragging: snapshot.isDragging }, tslib.__assign(tslib.__assign({}, draggableProvided.draggableProps), { style: tslib.__assign(tslib.__assign({}, draggableProvided.draggableProps.style), row.getRowProps().style) })),
                                    row.cells.map(function (cell) {
                                        return (React__default['default'].createElement("div", tslib.__assign({}, cell.getCellProps(), { className: styles$4.col, title: typeof cell.value === 'string'
                                                ? cell.value
                                                : undefined }), cell.render('Cell')));
                                    }),
                                    actions && (React__default['default'].createElement("div", { className: styles$4.actions, "data-test": "actions" }, actions(row.original))),
                                    React__default['default'].createElement(DragHandle, tslib.__assign({}, draggableProvided.dragHandleProps)))); }));
                            }),
                            droppableProvided.placeholder)));
                })))));
}

var styles$1 = {"root":"TruncatedCell-module_root__3syn5"};

function TruncatedCell(_a) {
    var value = _a.value;
    return React__default['default'].createElement("span", { className: styles$1.root }, value);
}

function Textarea(_a) {
    var error = _a.error, _b = _a.horizontal, horizontal = _b === void 0 ? true : _b, id = _a.id, label = _a.label, labelClass = _a.labelClass, required = _a.required, rest = tslib.__rest(_a, ["error", "horizontal", "id", "label", "labelClass", "required"]);
    var classes = classnames__default['default']({ error: error });
    return (React__default['default'].createElement(FormGroup, { horizontal: horizontal, errors: error ? [error] : [] },
        React__default['default'].createElement(FormGroupText, null,
            React__default['default'].createElement("label", { className: labelClass, htmlFor: id },
                label,
                " ",
                required && '*'),
            React__default['default'].createElement("textarea", tslib.__assign({ id: id, className: classes }, rest)))));
}

function Textfield(_a) {
    var className = _a.className, error = _a.error, _b = _a.horizontal, horizontal = _b === void 0 ? true : _b, id = _a.id, label = _a.label, labelClass = _a.labelClass, required = _a.required, rest = tslib.__rest(_a, ["className", "error", "horizontal", "id", "label", "labelClass", "required"]);
    var classes = classnames__default['default']({ error: error });
    return (React__default['default'].createElement(FormGroup, { horizontal: horizontal, errors: error ? [error] : [], className: className },
        React__default['default'].createElement(FormGroupText, null,
            React__default['default'].createElement("label", { className: labelClass, htmlFor: id },
                label,
                " ",
                required && '*'),
            React__default['default'].createElement("input", tslib.__assign({ id: id, type: "text", className: classes }, rest)))));
}

var styles = {"root":"Toast-module_root__2UTVL","close":"Toast-module_close__2jqxJ"};

function Toast(_a) {
    var _b;
    var className = _a.className, iconColour = _a.iconColour, iconName = _a.iconName, iconTestId = _a.iconTestId, message = _a.message, onClose = _a.onClose, title = _a.title;
    var rootClasses = classnames__default['default']('toast', styles.root, className);
    var iconClasses = classnames__default['default']('toast__icon', (_b = {},
        _b["text-" + iconColour] = iconColour,
        _b));
    return (React__default['default'].createElement("div", { className: rootClasses },
        iconName && (React__default['default'].createElement(Icon, { className: iconClasses, name: iconName, testId: iconTestId })),
        React__default['default'].createElement("div", { className: "toast__body" },
            React__default['default'].createElement("div", { className: "toast__title" }, title),
            React__default['default'].createElement("div", { className: "toast__message" }, message)),
        onClose && (React__default['default'].createElement("span", { className: styles.close },
            React__default['default'].createElement(IconButton, { icon: "close", colour: "link", size: "large", onClick: onClose, "aria-label": "Dismiss toast" })))));
}

exports.Themes = void 0;
(function (Themes) {
    Themes["Dark"] = "dark";
    Themes["Default"] = "default";
})(exports.Themes || (exports.Themes = {}));

exports.Alert = Alert;
exports.Button = Button;
exports.Card = Card;
exports.CardContent = CardContent;
exports.CardFooter = CardFooter;
exports.CardHeader = CardHeader;
exports.Checkbox = Checkbox;
exports.DEFAULT_FIRST_MIDDLE_VAL = DEFAULT_FIRST_MIDDLE_VAL;
exports.DEFAULT_PROPS = DEFAULT_PROPS;
exports.DragHandle = DragHandle;
exports.DraggableContainer = DraggableContainer;
exports.Footer = Footer;
exports.FormGroup = FormGroup;
exports.FormGroupText = FormGroupText;
exports.Header = Header;
exports.Heading = Heading;
exports.Icon = Icon;
exports.IconButton = IconButton;
exports.Image = Image;
exports.Label = Label;
exports.LinkButton = LinkButton;
exports.LoaderDots = LoaderDots;
exports.LoaderSpinner = LoaderSpinner;
exports.MAX_NUM_LINKS = MAX_NUM_LINKS;
exports.MAX_NUM_MIDDLE_LINKS = MAX_NUM_MIDDLE_LINKS;
exports.NavLinks = NavLinks;
exports.NavigationTabs = NavigationTabs;
exports.NumberInput = NumberInput;
exports.Pagination = Pagination;
exports.PaginationItem = PaginationItem;
exports.ResizeHandle = ResizeHandle;
exports.Search = Search;
exports.Select = Select;
exports.SideTabs = SideTabs;
exports.Step = Step;
exports.Steps = Steps;
exports.Switch = Switch;
exports.Table = Table;
exports.TableDraggableRows = TableDraggableRows;
exports.Textarea = Textarea;
exports.Textfield = Textfield;
exports.ThemeProvider = ThemeProvider;
exports.ThemeSwitch = ThemeSwitch;
exports.Toast = Toast;
exports.TruncatedCell = TruncatedCell;
exports.stopEventBubbling = stopEventBubbling;
exports.useTheme = useTheme;
